const colorfulIcons = {
    'icon-alert-like': 31,
    'icon-alert-success': 2,
    'icon-alert-exclamation': 2,
    'icon-tag-circle': 2,
    'icon-mobile-circle': 3,
    'icon-mobile-circle-pink': 3,
    'icon-gift-circle-green': 3,
    'icon-alert-exclamation-2': 2,
};

export const OoredooIcon = (className, wrap= false) => {
    if (typeof window.ooredoo_app === 'undefined'){
         window.ooredoo_app = {};
    }
    if (typeof window.ooredoo_app.icons === 'undefined'){
         window.ooredoo_app.icons = {};
    }

    if (typeof colorfulIcons[className] === 'undefined') {
        return `<i class="${className}"></i>`;
    } else if (typeof window.ooredoo_app.icons[className] !== 'undefined') {
        return window.ooredoo_app.icons[className];
    }
    let icon = '';
    for (let i = 1; i <= colorfulIcons[className]; ++i) {
        icon += `<span class="path${i}"></span>`;
    }
    window.ooredoo_app.icons[className] = `<span class="${className}">${icon}</span>`
    if (wrap){
        window.ooredoo_app.icons[className] = `<span class="ooredoo-icon-wrapper">${window.ooredoo_app.icons[className]}</span>`
    }
    return window.ooredoo_app.icons[className];
}
